import request from '@/utils/request'
const BASE_URL = '/RpWoDoc'

//核销单
export default {
  list(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  },
  info(id) {
    return request({
      url: BASE_URL + '/Info',
      method: 'get',
      params: { id }
    })
  },
  save(data) {
    return request({
      url: BASE_URL + '/Save',
      method: 'post',
      data
    })
  },
  delete(data) {
    return request({
      url: BASE_URL + '/Delete',
      method: 'post',
      data
    })
  },
  //获取列表 应收单
  needRcvList(data) {
    return request({
      url: BASE_URL + '/VRpNeedRcvList',
      method: 'post',
      data
    })
  },
  //获取列表 应收明细
  needRcvDetail(data) {
    return request({
      url: BASE_URL + '/VRpNeedRcvDetailList',
      method: 'post',
      data
    })
  },
  //获取列表 应付单
  needPayList(data) {
    return request({
      url: BASE_URL + '/VRpNeedPayList',
      method: 'post',
      data
    })
  },
  //获取列表 应付明细
  needPayDetail(data) {
    return request({
      url: BASE_URL + '/VRpNeedPayDetailList',
      method: 'post',
      data
    })
  }
}